import { render } from "./CreateDmeNeeded.vue?vue&type=template&id=2dfdb5c8&ts=true"
import script from "./CreateDmeNeeded.ts?vue&type=script&lang=ts&external"
export * from "./CreateDmeNeeded.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__